import { render } from "./yos-radio.vue?vue&type=template&id=d86da6c8"
import script from "./yos-radio.vue?vue&type=script&lang=js"
export * from "./yos-radio.vue?vue&type=script&lang=js"

import "./yos-radio.vue?vue&type=style&index=0&id=d86da6c8&lang=postcss"
script.render = render

export default script